<template>
  <div id="app">
    <router-view/>
    <transition name="el-zoom-in-top">
    <div class="back-top" v-show="showBackTopBtn">
        <el-button type="primary" icon="el-icon-arrow-up" @click="backToTop()"></el-button>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    window.addEventListener('scroll', this.handleScroll,true);
  },
  methods: {
    handleScroll () {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(this.scrollTop > 150){
        this.showBackTopBtn = true;
      }
      else{
        this.showBackTopBtn = false;
      }
    },
    backToTop(){
      let timer = null, _that = this
        //动画，使用requestAnimationFrame代替setInterval
        cancelAnimationFrame(timer)
        timer = requestAnimationFrame(function fn() {
          if (_that.scrollTop > 0) {
            _that.scrollTop -= 50
            document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop
            timer = requestAnimationFrame(fn)
          } else {
            cancelAnimationFrame(timer)
            _that.toTopShow = false
          }
        })
    }
  },

  data(){
    return{
        showBackTopBtn:false,
    }
  }
}
</script>

<style>
  body{
    margin: 0;
    height: 100%;
  width: 100%;
    min-width: 500px;
    overflow-x: auto;
    font-family: "Microsoft YaHei","微软雅黑","Helvetica Neue","Helvetica","PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
#app {
  font-family: "Microsoft YaHei","微软雅黑",'Avenir', "Helvetica", "Arial", "sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*background-color: red;*/
  height: 100%;
  width: 100%;

    /*background-size:100% 100%;*/
    /*-moz-background-size:100% 100%;*/
}

  .text-align-left{
    text-align: left;
  }
  .text-align-right{
    text-align: right;
  }
  a{
    text-decoration: none;
  }
  .back-top{
    position: fixed;
    bottom: 80px;
    right: 40px;

  }
  .back-top .el-button{
    font-size: 32px;
    padding: 8px;
    background-color: #0053a1;
    border: 1px solid #0053a1;
  }
  .text-red{
    color: red;
  }
  .text-blue{
    color: blue;
  }
  .font-weight{
    font-weight: bolder;
  }
  .text-indent-null{
    text-indent: 0;
  }
  .text-main-color{
    color: #0053a1;
  }

  .top-content  .right-content a{
    color: #0053a1;
  }
  .top-right .right-content a:hover{
    cursor: pointer;
    color: #f27d00;
  }
  .news-item .iconfont{
    margin-right: 4px;
  }
  .footer{
    border-top: 2px solid #aaaaaa;

  }
  .footer p{
    padding-bottom: 16px;
  }

  @media screen and (max-width: 800px){
    body{
      min-width: 300px;
      width: 100%;
      overflow-x: hidden;
      /*background-image: url("../static/images/app_bg.jpg");*/
      /*background-repeat: repeat;*/
    }
    .back-top{
      position: fixed;
      bottom: 40px;
      right: 20px;

    }
  }
</style>

<!--0053a1-->



// WEBPACK FOOTER //
// src/App.vue